import styled from 'styled-components';
import backgroundImage from './../../../assets/background-header.webp'

export const StickyWrapper = styled.div`
  position: sticky;
  top: 0; /* Fixa no topo ao rolar */
  z-index: 10; /* Certifica-se de que fique acima de outros elementos */
  background: white; /* Garante que o fundo seja branco */
  border-bottom: 1px solid #ccc; /* Linha inferior para separação */
  width: 100%; /* Ocupar a largura total */
`;
